import script from "./FavoriteMenuList.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteMenuList.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteMenuList.vue?vue&type=style&index=0&id=41a17bb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a17bb2"]])

export default __exports__